import script from "./Top20.vue?vue&type=script&setup=true&lang=js"
export * from "./Top20.vue?vue&type=script&setup=true&lang=js"

import "./Top20.vue?vue&type=style&index=0&id=7f43e722&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f43e722"]])

export default __exports__